import { InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

export default function CustomSearchBar({ searchQuery, handleSearch }) {
    return (
        <TextField
            variant="outlined"
            value={searchQuery}
            onChange={handleSearch}
            sx={{
                pb: 2, width: 400, '& .MuiOutlinedInput-root': {
                    borderRadius: '8px'
                }
            }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                ),
                placeholder: 'Search Emission Factors',
            }}
        />
    )
}
